import {
  externalHrefForLinkField,
  isEmailFieldType,
} from "@/utils/linkFieldValue";

type Props = {
  fieldType: string;
  value: unknown;
  className?: string;
};

function displayText(value: unknown): string {
  if (value == null) return "—";
  const s = String(value).trim();
  return s || "—";
}

/** Read-only link display for table cells and detail views. */
export function LinkFieldDisplay({ fieldType, value, className }: Props) {
  const text = displayText(value);
  const href =
    text === "—" ? null : externalHrefForLinkField(fieldType, value);

  if (!href) {
    return <span className={className}>{text}</span>;
  }

  const openLabel = isEmailFieldType(fieldType) ? "Send email" : "Open link";

  return (
    <span className={className}>
      <a
        href={href}
        target={isEmailFieldType(fieldType) ? undefined : "_blank"}
        rel={isEmailFieldType(fieldType) ? undefined : "noopener noreferrer"}
        className="text-primary font-medium underline-offset-2 hover:underline"
        onClick={(e) => e.stopPropagation()}
      >
        {text}
      </a>
      <span className="sr-only"> ({openLabel})</span>
    </span>
  );
}
